import { useState } from "react";
import LandingPage from "./components/LandingPage";
import LoginForm from "./components/LoginForm";
import Dashboard from "./components/Dashboard";
import SamlCallback from "./components/SamlCallback";
import MobileNotSupported from "./components/MobileUnsupported";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { isMobileDevice } from "./utils/isMobileDevice";

function App() {
    // Lazy initializer so the UA check only runs once, not on every render.
    const [isMobile] = useState(isMobileDevice);

    if (isMobile) {
        return <MobileNotSupported />;
    }

    return (
        <AuthProvider>
            <Router basename={process.env.PUBLIC_URL}>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/login" element={<LoginForm />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/saml/callback" element={<SamlCallback />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;